import React, { useEffect, useState } from 'react';
import ReactRouter from 'react-router';
import axios from 'axios';
import qs from 'qs';
import classNames from 'classnames';
import { LoginBase } from './LoginBase';
import { SignInForm } from './Forms/LoginForm';
import { SignUpForm } from './Forms/SignUpForm';
import { SupplierContent, SupplierHeader } from './MagicLinkLogin';
import PasswordResetForm from './Forms/PasswordResetForm';
import {
  FormState,
  MessageBannerState,
  RouteParams,
} from './Forms/index.types';
import { Header } from './DefaultLogin';

export const InvitationLogin = (
  props: ReactRouter.RouteComponentProps<RouteParams, {}>
) => {
  const { location, params } = props;
  const { supplierId, token, existingUser } = qs.parse(location.search, {
    ignoreQueryPrefix: true,
  }) as any;

  const initialBannerState: MessageBannerState | undefined =
    existingUser === 'true' ? 'welcomeBack' : undefined;
  const initialFormState: FormState =
    existingUser === 'true' ? 'signIn' : 'signUp';

  const [supplierState, setSupplierState] = useState<any>();
  const [recipientEmail, setRecipientEmail] = useState<string>();
  const [formState, setFormState] = useState<FormState>(initialFormState);
  const [bannerState, setBannerState] = useState<
    MessageBannerState | undefined
  >(initialBannerState);

  useEffect(() => {
    if (supplierId) {
      (async function getSupplier() {
        const res = await axios.get(`/v1/suppliers/directory/${supplierId}`);
        setSupplierState(res.data);
      })();
    }
  }, [supplierId]);

  useEffect(() => {
    if (token) {
      (async function checkInvitation() {
        const res = await axios.get(`/v1/invites/${params.id}?token=${token}`, {
          timeout: 5000,
        });
        if (res.data.expired || res.data.status === 'Accepted') {
          setFormState('signIn');
          setBannerState('expiredInvitation');
        }
        if (res.data.recipientEmail) {
          setRecipientEmail(res.data.recipientEmail ?? '');
        }
      })();
    }
  }, [token]);

  return (
    <LoginBase
      type="magicLink"
      header={
        supplierState ? (
          <SupplierHeader supplier={supplierState} />
        ) : (
          <div className="flex justify-center items-center">
            <Header />
          </div>
        )
      }
    >
      <div
        className={classNames('flex w-full gap-20', {
          'justify-center items-center': !supplierState,
        })}
      >
        {supplierState && <SupplierContent supplier={supplierState} />}
        {
          {
            signIn: (
              <SignInForm
                messageBannerState={bannerState}
                onSignUpClick={() => setFormState('signUp')}
                destination={`/dashboard?inviteId=${params.id}&token=${token}`}
                onPasswordResetClick={() => setFormState('passwordReset')}
                {...props}
              />
            ),
            signUp: (
              <SignUpForm
                inviteId={params.id}
                inviteToken={token}
                mode="invitation"
                recipientEmail={recipientEmail}
                registrationSuccessDestination={`/dashboard?inviteId=${params.id}&token=${token}`}
                onSignInClick={() => setFormState('signIn')}
                {...props}
              />
            ),
            passwordReset: (
              <PasswordResetForm onBackClick={() => setFormState('signIn')} />
            ),
          }[formState]
        }
      </div>
    </LoginBase>
  );
};
